module.exports = __webpack_public_path__ + "img/circle-group-color.0c40964c.png";